export default __webpack_public_path__ + "static/media/netlify.16fa7138.svg";